import Abstract from './abstract.js';

class Tabs extends Abstract {

	constructor(node, config = {}) {
		config = Object.assign({
			contentsOpenClass: 'tabs__tab--open',
			titleClass: 'tabs__title',
		}, config);

		super(node, config);

		if (!this.tabs) {
			return;
		}

		this.open(this.index, false);

		this.titles = Array.from(this.node.querySelectorAll(`.${this.config.titleClass}`)).map((title, index) => {
			title.addEventListener('click', (e) => {
				e.preventDefault();
				this.toggle(index);
			});

			return title;
		});
	}

	goToHash(hash, history = true) {
		super.goToHash(hash, history);

		if (this.hashMap[hash] > -1) {
			this.open(this.hashMap[hash], history);
		}
	}

	open(index, history) {
		this.tabs[index].opened = true;
		this.tabs[index].content.classList.add(this.config.contentsOpenClass);
		this.goTo(index, history);
	}

	close(index) {
		this.tabs[index].opened = false;
		this.tabs[index].content.classList.remove(this.config.contentsOpenClass);
	}

	toggle(index) {
		return this.tabs[index].opened ? this.close(index) : this.open(index);
	}

}

Tabs.instances = Array.from(document.querySelectorAll('.tabs')).map(n => new Tabs(n));

export default Tabs;
